export default "__VITE_ASSET__BEvFkFzh__"